import React from 'react';

import { useRouteMatch } from 'react-router';

import Loader from 'components/shared/Loader';
import { CSS_REDACTOR_PATH } from 'constants/routes';

const BaseRedactor = React.lazy(() => import('./BaseRedactor'));
const SeparateRedactor = React.lazy(() => import('./SeparateRedactor'));

function CodeRedactor(props) {
  const match = useRouteMatch(CSS_REDACTOR_PATH);

  return (
    <React.Suspense fallback={<Loader />}>
      {match && <SeparateRedactor {...props} />}
      {!match && <BaseRedactor {...props} />}
    </React.Suspense>
  );
}

export default CodeRedactor;
